const styles = theme => ({
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    minWidth: '760px',
    width: '100%',
    margin: '24px auto',
    height: '100%',
    padding: '8px 4px',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px 15px',
    maxHeight: '630px',
    overflow: 'auto',
    maxWidth: '760px',
    width: '100%',
    height: '100%',
    '@media (max-width: 1024px)': {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
    '@media (max-width: 768px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@media (max-width: 480px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '280px',
    width: '760px',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    borderRadius: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    width: '175px',
    height: '120px',
    position: 'relative',
    gap: '8px',
    '&:hover': {
      cursor: 'pointer',
      border: '1px solid #015FFB',
      backgroundColor: '#E3F3FF',
    },
  },
  image: {
    width: '24px',
    height: '24px',
  },
  title: {
    fontSize: '13px',
    fontWeight: '500',
    color: '#002E47',
    textAlign: 'center',
  },
  headerDiv: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  headerText: {
    fontSize: '10px',
    fontWeight: 400,
    color: '#919EAB',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
    marginTop: '24px',
  },
  backButton: {
    minWidth: '100px',
  },
  addButton: {
    minWidth: '120px',
  },
  header: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#212B36',
  },
  uploadSection: {
    marginTop: '24px',
    width: '100%',
  },
  aiHelpText: {
    fontSize: '14px',
    color: '#637381',
    marginTop: '8px',
  },
  numberInputContainer: {
    width: '100%',
  },
  numberInputLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#002E47',
    marginBottom: '8px',
  },
  numberInput: {
    width: '120px',
  },
  inputButton: {
    cursor: 'pointer',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    color: '#637381',
    userSelect: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: '#015FFB',
    },
  },
})

export default styles
